import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e7294fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-input" }
const _hoisted_2 = { class: "item-label" }
const _hoisted_3 = { class: "item-label-alt" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: "",
  class: "item-placeholder-gray"
}, "Select", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "mt-1 item-validation-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
      required: "",
      class: _normalizeClass(["form-select ins-form-control item-body col-lg-auto col-md-auto col-sm-auto col-xs-12", { 'validation-error': _ctx.validationError }]),
      disabled: _ctx.isDisabled
    }, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.castedOptions, (option, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: option.value
        }, _toDisplayString(option.text), 9, _hoisted_6))
      }), 128))
    ], 10, _hoisted_4), [
      [_vModelSelect, _ctx.selectedValue]
    ]),
    (_ctx.validationError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.validationError), 1))
      : _createCommentVNode("", true)
  ]))
}